var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.83 6.69245H29.5947L19.0434 13.9258L11.8662 9.00558C12.1395 8.27389 12.1418 7.44683 11.83 6.69245ZM7.18393 10.8907L9.77331 9.31408C10.5417 8.8462 10.7968 7.84795 10.3469 7.06876L8.00925 3.01976C7.76943 2.60433 7.40643 2.33708 6.93856 2.23145C6.47062 2.12576 6.02812 2.21108 5.633 2.48314L1.36975 5.41839C-0.659567 12.5686 8.45974 28.0486 15.4537 29.8125L20.1274 27.5881C20.5605 27.382 20.8557 27.0413 20.9981 26.5833C21.1406 26.1252 21.0906 25.6773 20.8507 25.2618L18.5131 21.2128C18.0632 20.4336 17.0712 20.1554 16.2817 20.587L13.6217 22.0411C10.9911 19.7015 7.89481 14.3387 7.18393 10.8907ZM30.8849 7.6227L19.4652 15.4513C19.1981 15.6337 18.8547 15.6195 18.6064 15.441L11.0252 10.2438C10.8816 10.3733 10.7242 10.4913 10.5534 10.5953L8.91562 11.5925C9.77606 14.3693 11.9051 18.057 13.8797 20.1905L15.5622 19.2708C17.0654 18.449 18.9554 18.9791 19.812 20.4628L21.2617 22.9738H29.706C30.3727 22.9738 30.9182 22.4283 30.9182 21.7616V7.9047C30.9183 7.8077 30.9067 7.71326 30.8849 7.6227Z",
    fill: "#00AC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.debc55925a157914828fbcbe01ca6f88.svg";
export { ForwardRef as ReactComponent };